import WarehouseTransferList from '@/components/WarehouseTransfer/WarehouseTransferList'
import WarehouseTransferForm from '@/components/WarehouseTransfer/WarehouseTransferForm'
import WarehouseTransferDetail from '@/components/WarehouseTransfer/WarehouseTransferDetail'

let WarehouseTransferRouter = [
  {
    path: '/warehouse-transfer',
    name: 'WarehouseTransferList',
    component: WarehouseTransferList,
    meta: {
      title: 'Transferts inter-entrepôts',
      requiresAuth: true,
      authorizations: ['warehouse-transfer_index', 'desktop_access']
    }
  },
  {
    path: '/warehouse-transfer/new',
    name: 'WarehouseTransferForm',
    component: WarehouseTransferForm,
    meta: {
      title: 'Nouveau transfert inter-entrepôts',
      requiresAuth: true,
      authorizations: ['warehouse-transfer_new', 'desktop_access']
    }
  },
  {
    path: '/warehouse-transfer/:id',
    name: 'WarehouseTransferDetail',
    component: WarehouseTransferDetail,
    meta: {
      title: 'Fiche transfert inter-entrepôts',
      requiresAuth: true,
      authorizations: ['warehouse-transfer_show', 'desktop_access']
    }
  }
]

export default WarehouseTransferRouter



// WEBPACK FOOTER //
// ./src/components/WarehouseTransfer/router.js